import { c as _c } from "react/compiler-runtime";
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { twMerge } from 'tailwind-merge';
import RichTextHtml from '~/components/RichTextHtml';
export type AspectRatio = '16to9' | '4to3' | 'square';
export default function EmbedBlock(t0) {
  const $ = _c(15);
  const {
    title,
    description,
    embedUrl,
    aspectRatio: t1
  } = t0;
  const aspectRatio = t1 === undefined ? "16to9" : t1;
  const t2 = aspectRatio === "16to9" && "aspect-16/9";
  const t3 = aspectRatio === "4to3" && "aspect-4/3";
  const t4 = aspectRatio === "square" && "aspect-1";
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = twMerge("w-full relative", t2, t3, t4);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== embedUrl || $[5] !== title) {
    t6 = <iframe className="absolute inset-0 w-full h-full border-0" src={embedUrl} title={title} loading="lazy" referrerPolicy="strict-origin-when-cross-origin" allow="autoplay *; fullscreen *; encrypted-media *; gyroscope; picture-in-picture; web-share" sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation" allowFullScreen={true} />;
    $[4] = embedUrl;
    $[5] = title;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== description) {
    t8 = description && <div><RichTextHtml data={description} /></div>;
    $[10] = description;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <div className="w-full space-y-4">{t7}{t8}</div>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}